<template>
  <b-card no-body>
    <b-card-body class="d-flex justify-content-between align-items-center">
      <div class="truncate">
        <div class="text-muted mb-25">
          {{ title }}
        </div>
        <h2 class="mb-0 font-weight-bolder">
          {{ formatNumber(usage) }}
          <small
            v-if="!hideLimit && Number(limit) > 0"
            class="text-muted font-medium-1 font-weight-normal"
          >
            / {{ formatNumber(limit) }}
          </small>
        </h2>
      </div>
      <b-avatar
        :variant="`light-${color}`"
        size="45"
      >
        <feather-icon
          size="21"
          :icon="icon"
        />
      </b-avatar>
    </b-card-body>
  </b-card>
</template>

<script>
import { BAvatar, BCard, BCardBody } from 'bootstrap-vue'

export default {
  name: 'StatMetricCard',
  components: {
    BAvatar,
    BCard,
    BCardBody,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    usage: {
      type: [Number, String],
      default: 0,
    },
    limit: {
      type: [Number, String],
      default: 0,
    },
    icon: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'primary',
    },
    hideLimit: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatNumber(value) {
      const num = Number(value)
      if (Number.isNaN(num)) return '0'
      return new Intl.NumberFormat('tr-TR', {
        maximumFractionDigits: 1,
      }).format(num)
    },
  },
}
</script>
